module.exports = __webpack_public_path__ + "static/media/theme-corporate.70959605.png";